const ALERT_COMMAND_MESSAGE = {
  NOTIFICATION_REQUEST: "CMD_MWDEV:NOTIFICATION_REQUEST",
  RECONNECT_WEBSOCKET: "CMD_MWDEV:RECONNECT_WEBSOCKET",
  MEETING_ALERT: "CMD_MWDEV:MEETING_ALERT",
};

export default ALERT_COMMAND_MESSAGE;
